import type { CSSProperties, ReactNode } from 'react'

interface CalcBadgeProps {
  children?: ReactNode
  style?: CSSProperties
}

/**
 * "▦ Calculated" badge — neutral, mono, small.
 * Used in CalcPanel header and standalone.
 * Must NOT carry indigo chrome (Rule 07).
 */
export function CalcBadge({ children = 'Calculated', style }: CalcBadgeProps): JSX.Element {
  return (
    <span
      data-testid="calc-badge"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        height: 18,
        padding: '0 8px',
        borderRadius: 4,
        background: 'rgba(107, 99, 89, 0.10)',
        color: 'var(--text-2)',
        fontFamily: 'var(--font-mono)',
        fontSize: 9,
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      <span aria-hidden="true" style={{ fontSize: 9, letterSpacing: 0 }}>▦</span>
      {children}
    </span>
  )
}
